import(/* webpackMode: "eager" */ "/home/runner/work/oxpa.pro/oxpa.pro/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.61.1_react-dom@18_xshnae27y3nb6d47smdske3idq/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/home/runner/work/oxpa.pro/oxpa.pro/src/app/_components/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicHeader"] */ "/home/runner/work/oxpa.pro/oxpa.pro/src/app/(public)/_components/public-header.tsx");
